import pb from '../lib/pocketbase';

export async function getDeliveries(page, perPage) {
  return await pb.collection('delivery').getList(page, perPage, {
    sort: '-created',
    $autoCancel: false,
    expand: 'relatedField' // Replace 'relatedField' with any field you want to expand
  });
}

export async function createDelivery(delivery) {
  return await pb.collection('delivery').create(delivery);
}

export async function updateDelivery(id, delivery) {
  return await pb.collection('delivery').update(id, delivery);
}

export async function deleteDelivery(id) {
  return await pb.collection('delivery').delete(id);
}